import React from "react";
import { IMAGES } from "@/lib/brands";

const Stat = ({ value, label }) => (
  <div className="border-t border-black/15 pt-4">
    <div className="font-display text-4xl md:text-5xl leading-none">{value}</div>
    <div className="eyebrow text-black/50 mt-2">{label}</div>
  </div>
);

const OwnerCard = ({ role, name, email }) => (
  <div className="border border-black/15 p-4">
    <div className="eyebrow text-[color:var(--primary)] mb-1">{role}</div>
    <div className="font-display text-lg uppercase">{name}</div>
    {email && <div className="text-xs text-black/60 mt-1">{email}</div>}
  </div>
);

const About = () => {
  return (
    <section
      id="about"
      className="section-pad bg-white relative"
      data-testid="about-section"
    >
      <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-6 order-2 lg:order-1">
          <div className="eyebrow text-[color:var(--primary)] mb-4">
            ◆ About
          </div>
          <h2 className="font-display text-4xl md:text-6xl uppercase leading-[0.95] tracking-tighter mb-8">
            100% Minority <br />
            Women-Owned.
          </h2>
          <p className="text-black/75 leading-relaxed mb-5">
            Owned and operated by <strong>Michelle "Mickey" Coffino</strong>{" "}
            and <strong>Serena Coffino</strong>, with{" "}
            <strong>Nathan Gates</strong> managing daily yard operations. Our
            family of yards has served the southern region for more than 15
            years — committed to safety, integrity, and excellent customer
            service on every load.
          </p>
          <p className="text-black/75 leading-relaxed mb-10">
            Between our two locations — Queen City Metal in Charlotte and
            Dale's Recycling in Hudson — we operate a full metal recycling
            facility, a convenient pickup service, and a legacy of being more
            than a scrap yard. We're an employer, a community partner, and a
            second chance.
          </p>

          <div className="grid grid-cols-3 gap-6">
            <Stat value="15+" label="Years" />
            <Stat value="02" label="Yards" />
            <Stat value="100%" label="Women-Owned" />
          </div>
        </div>

        <div className="lg:col-span-6 order-1 lg:order-2 relative">
          <div className="absolute -inset-4 border border-black/10 pointer-events-none hidden lg:block" />
          <img
            src={IMAGES.team}
            alt="Mickey Coffino — CEO of Queen City Metal Recycling"
            className="w-full aspect-[4/5] object-cover relative"
            data-testid="about-image"
          />
          <div className="mt-4 text-[10px] font-mono uppercase tracking-widest text-black/50">
            Photo: Vanessa Allen Photography
          </div>
          <div className="mt-4 grid grid-cols-2 gap-4">
            <OwnerCard
              role="CEO / Owner"
              name="Michelle 'Mickey' Coffino"
              email="mickey@qcrecycling.com"
            />
            <OwnerCard
              role="CEO / Owner"
              name="Serena Coffino"
              email="serena@qcrecycling.com"
            />
            <OwnerCard
              role="Yard Manager"
              name="Nathan Gates"
              email="Nathan@qcrecycling.com"
            />
            <OwnerCard
              role="General Manager"
              name="Angela Cline"
              email="Angela@qcrecycling.com"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
